// Imports
import barba from '@barba/core';

class Url {
    constructor() {}
    add(url, action = 'push') {
        barba.history.add(url, 'barba', action);
    }
}

export default new Url();
